<template>
  <div class="versions">
    <CurrVersions />
    <h1>Versions</h1>
    <div class="table-wrapper loader-container">
      <vue-good-table
        :columns="[
          {
            label: 'Version',
            field: 'version1',
            sortFn: this.sortVersion
          },
          {
            label: 'Compile Date',
            field: 'compileDate',
            formatFn: formatDateTime
          },
          {
            label: 'Alpha Date',
            field: 'alphaDate',
            formatFn: formatDateTime
          },
          {
            label: 'Beta Date',
            field: 'betaDate',
            formatFn: formatDateTime
          },
          {
            label: 'Release Date',
            field: 'releaseDate',
            formatFn: formatDateTime
          },
          {
            label: 'Stable Date',
            field: 'stableDate',
            formatFn: formatDateTime
          },
          {
            label: 'Release Notes',
            field: 'releaseNotes'
          }
        ]"
        :rows="versions"
      >
        <template slot="table-row" slot-scope="props">
          <button
            v-if="
              props.column.field == 'alphaDate' &&
                !props.row.alphaDate &&
                sortVersion(props.row.version1, currentVersions.alphaVersion) ==
                  1
            "
            @click.prevent="setVersionAlpha(props.row.version1)"
          >
            Set
          </button>

          <button
            v-else-if="
              props.column.field == 'betaDate' &&
                !props.row.betaDate &&
                sortVersion(props.row.version1, currentVersions.betaVersion) ==
                  1
            "
            @click.prevent="setVersionBeta(props.row.version1)"
          >
            Set
          </button>

          <button
            v-else-if="
              props.column.field == 'releaseDate' &&
                !props.row.releaseDate &&
                sortVersion(
                  props.row.version1,
                  currentVersions.releaseVersion
                ) == 1
            "
            @click.prevent="setVersionRelease(props.row.version1)"
          >
            Set
          </button>

          <button
            v-else-if="
              props.column.field == 'stableDate' &&
                !props.row.stableDate &&
                sortVersion(
                  props.row.version1,
                  currentVersions.stableVersion
                ) == 1
            "
            @click.prevent="setVersionStable(props.row.version1)"
          >
            Set
          </button>
          <span v-else-if="props.column.field == 'releaseNotes'">
            <pre>{{ formatReleaseNotes(props.row.releaseNotes) }}</pre>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template></vue-good-table
      >
      <Loader :loading="loadingVersions" />
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import CurrVersions from "@/components/CurrVersions.vue";
import { VueGoodTable } from "vue-good-table";
import { mapState } from "vuex";
import service from "@/services/service.js";

export default {
  components: { Loader, VueGoodTable, CurrVersions },
  computed: {
    ...mapState(["currentVersions"])
  },
  data() {
    return {
      versions: [],
      loadingVersions: false
    };
  },
  created() {
    this.getVersions();
  },
  methods: {
    getVersions() {
      var self = this;
      self.loadingVersions = true;
      service
        .getVersions()
        .then(response => {
          self.versions = response.data;
          self.loadingVersions = false;
        })
        .catch(() => {
          self.loadingVersions = false;
        });
    },
    refresh() {
      var self = this;
      service.getCurrentVersions().then(response => {
        this.$store.dispatch("setCurrentVersions", response.data[0]);
        self.getVersions();
      });
    },
    setVersionAlpha(version) {
      var self = this;
      service
        .setVersionAlpha(version)
        .then(() => {
          self.refresh();
        })
        .catch(() => {});
    },
    setVersionBeta(version) {
      var self = this;
      service
        .setVersionBeta(version)
        .then(() => {
          self.refresh();
        })
        .catch(() => {});
    },
    setVersionRelease(version) {
      var self = this;
      service
        .setVersionRelease(version)
        .then(() => {
          self.refresh();
        })
        .catch(() => {});
    },
    setVersionStable(version) {
      var self = this;
      service
        .setVersionStable(version)
        .then(() => {
          self.refresh();
        })
        .catch(() => {});
    }
  }
};
</script>
